import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Box, Grid, Typography } from '@mui/material'
import InputField from '../../../../FormControl/input/InputField'
import { SelectMultipleFieldYears } from '../../../../FormControl/SelectRequest/SelectMultipleFieldYears'
import InputDateUTC from '../../../../FormControl/input/InputDateUTC'

const FormBasicInformation = ({ onChangeAlert }) => {
  const formData = useSelector((state) => state?.dr?.form || {})
  const formError = useSelector((state) => state?.dr?.formError || {})
  const currentCurriculum = useSelector((state) => state?.assessment?.currentCurriculum || {})
  const [form, setInputForm] = React.useState(formData)
  const [errors, setInputErrors] = React.useState({})

  if (!currentCurriculum || !currentCurriculum?.elements || !currentCurriculum.elementsStructure) return <></>
  const onChange = (name, value) => {
    if (name === 'startDate' || name === 'endDate') {
      let newValue = value;
      if (value === '') {
        newValue = null;
      }

      setInputForm({ ...form, [name]: newValue })
      setInputErrors({ ...errors, [name]: null })
      onChangeAlert(name, newValue)
    } else {
      setInputForm({ ...form, [name]: value })
      setInputErrors({ ...errors, [name]: null })
      onChangeAlert(name, value)
    }
  }
  useEffect(() => {
    setInputErrors(formError)
  }, [formError])

  return (
    <>
      <Box className='px-4 py-2 h-6 bg-primary text-primary-foreground flex items-center'>
        <Typography variant='inherit' className='font-bold capitalize' component='p'>
          Basic Information
        </Typography>
      </Box>
      <Box className='px-4 py-4'>
        <Grid container spacing={2} alignItems='center'>
          <Grid item md={2} sm={3}>
            <Typography variant='inherit' className='font-bold capitalize' color='primary' align='right' component='p'>
              Name
            </Typography>
          </Grid>
          <Grid item md={9} sm={8}>
            <InputField
              id='name' 
              name='name' 
              error={errors.name}
              helperText={errors.name}
              value={form.name}
              onChange={(e) => onChange('name', e.target.value)}      
            />
          </Grid>
          <Grid item md={2} sm={3}>
            <Typography variant='inherit' className='font-bold capitalize' color='primary' align='right' component='p'>
              Year level
            </Typography>
          </Grid>
          <Grid item md={9} sm={8}>
            <SelectMultipleFieldYears
              id='yearLevel'
              name='yearLevel' 
              error={errors.yearLevel}
              helperText={errors.yearLevel}
              value={form.yearLevel}
              onChange={(e) => onChange('yearLevel', e.target.value)}
              isPreview={formData?.linkedClasses?.length > 0}
            />
          </Grid>
          <Grid item md={2} sm={3}>
            <Typography variant='inherit' className='font-bold capitalize' color='primary' align='right' component='p'>
              Start Date
            </Typography>
          </Grid>
          <Grid item md={4} sm={4}>
            <InputDateUTC
              id='dr-start-date'
              name="startDate"    
              value={form?.startDate}  
              maxDate={formData?.maxStartDate}
              helperText={errors?.startDate}                 
              error={errors?.startDate}  
              onChange={value =>  onChange('startDate', value)}              
            />
          </Grid>
          <Grid item md={1} sm={2}>
            <Typography variant='inherit' className='font-bold capitalize' color='primary' align='right' component='p'>
              End Date
            </Typography>
          </Grid>
          <Grid item md={4} sm={4}>
            <InputDateUTC
              id='dr-end-date'
              name="endDate"    
              value={form?.endDate}  
              minDate={formData?.minEndDate}
              helperText={errors?.endDate}                 
              error={errors?.endDate}  
              isStartOfTheDay={false}
              onChange={value =>  onChange('endDate', value)}              
            />
          </Grid>
        </Grid>
      </Box>
    </>

  )
}

export default FormBasicInformation